module.exports = __webpack_public_path__ + "img/icon_map_nh.1fe23a43.png";